angular.module('unica_pages.pages_controllers', [])

.controller('CookiesPageController', function() {

})

.controller('PrivacyPageController', function() {


});